import TrackCard from 'components/TrackCard/TrackCard'

import { isEmpty } from 'lodash'
import LoadingBlocker from '../LoadingSpinner/LoadingBlocker'
import { useContext } from 'react'
import { UploadContext } from '../../contexts/UploadContext'

const TrackList = ({
  tracks,
  onTrackClick,
  onTrackDoubleClick,
  selectedTracks = [],
  isLoading,
  search,
}) => {
  const uploadContext = useContext(UploadContext)
  const uploadingFiles = uploadContext.files
  return (
    <div className="">
      {tracks?.length > 0 ? (
        tracks.map((track, i) => {
          return (
            <TrackCard
              key={track.id}
              track={track}
              index={i}
              onTrackClick={onTrackClick}
              onTrackDoubleClick={onTrackDoubleClick}
              selectedTracks={selectedTracks}
            />
          )
        })
      ) : (
        <>
          {isEmpty(uploadingFiles) && (
            <div className="mt-6 p-6 mx-8 bg-gray border border-gray-dark rounded">
              {!search ? (
                <>
                  <h4 className="mb-4">No Tracks</h4>
                  <p>
                    To upload a track press the button above or drop your audio
                    files into this area.
                  </p>
                </>
              ) : (
                <>
                  <h4 className="mb-4">No Tracks Found</h4>
                  <p>There is no tracks found match your search.</p>
                </>
              )}
            </div>
          )}
        </>
      )}
      {isLoading && <LoadingBlocker />}
    </div>
  )
}

export default TrackList
